/**
 * 외부 URL
 */
export const EXTERNAL_URLS = {
  /** 개인정보 처리방침 */
  PRIVACY_POLICY: 'https://privacy.kurly.com/kurly/privacypolicy/partner/3pl/',

  /** [입고 관리] 입고 가이드 링크 */
  RECEIVE_GUIDE_LINK: 'https://docs.google.com/document/d/1seY4MOI6UW53BELGpX3D5mXZ_KyWnDbpxWbAuDoRsho/',

  /** [배송대행 관리] 운송장 조회 링크 */
  DELIVERY_AGENCY_TRACKING_LINK_CJT: 'https://trace.cjlogistics.com/web/detail.jsp?slipno=',
  DELIVERY_AGENCY_TRACKING_LINK_KURLY_NEXT_MILE: 'https://www.kurlynextmile.com/information/invoice?invoice_no=',
  DELIVERY_AGENCY_TRACKING_LINK_LTT: 'https://www.lotteglogis.com/home/reservation/tracking/linkView?InvNo=',
} as const;
